import { render, staticRenderFns } from "./ImportarVacinados.vue?vue&type=template&id=dd87af52&"
import script from "./ImportarVacinados.vue?vue&type=script&lang=js&"
export * from "./ImportarVacinados.vue?vue&type=script&lang=js&"
import style0 from "./ImportarVacinados.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports